import { FAILURE, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function obtenerInfoViajePorId(obj) {
    try {
        let data = { error: true, message: "" };
        const { code, body, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/viaje/obtener-info-viaje-por-id",
            {
                headers: getHeaders(false),
                method: "POST",
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (code === SUCCESS) {
            data.error = false;
            data.data = Array.isArray(body) && body.length > 0 ? body[0] : null;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("obtenerInfoViajePorId err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function cambiarEstadoViaje(obj) {
    try {
        let data = { error: true, message: "" };
        const { code, body, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/viaje/cambiar-estado-viaje",
            {
                headers: getHeaders(false),
                method: "POST",
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (code === SUCCESS) {
            data.error = false;
            // data.data = Array.isArray(body) && body.length > 0 ? body[0] : null;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("cambiarEstadoViaje err");
        console.log(err);
        return { error: true, message: err };
    }
}